export const headers_default = [
  {
    text: 'Tipo',
    value: 'tipo'
  },
  {
    text: 'Marca',
    value: 'razao_social'
  },
  {
    text: 'ID Produto',
    value: 'idproduto'
  },
  {
    text: 'Descrição Produto',
    value: 'descricao_produto'
  },
  {
    text: 'Data da Última Entrada',
    value: 'ultima_data_entrada'
  },
  {
    text: 'Preço Atual',
    value: 'preco_atual'
  },
  {
    text: 'Último Preço',
    value: 'ultimo_preco'
  },
  {
    text: 'Penúltimo Preço',
    value: 'penultimo_preco'
  }
];
